import { ComplexEnumItem } from '../../utils/complexEnum/ComplexEnumItem'
import { CIMSModuleItem } from '../CIMSModule/CIMSModuleItem'
import {
  CAS,
  Concrete,
  DS,
  FDC,
  RFI,
  Issues as Is,
} from '../CIMSModule/instances'

/**
 * this is not extending DetailedEnumItem on purpose
 */
export class SharePointParentFolderItem<
  ID extends string,
  Name extends string,
  ModuleID extends string,
  ModuleName extends string,
  ModulePathname extends string,
  ClassType extends string,
  PrimaryKey extends string
> extends ComplexEnumItem<ID> {
  readonly classType: ClassType
  /**
   * the name of the parent folder in SharePoint
   *
   * this is where all the various record folders live
   */
  readonly name: Name
  /**
   * which CIMS module the record's {@link SharePointParentFolderItem.description|parent}
   * is associated with
   */
  readonly module: CIMSModuleItem<ModuleID, ModuleName, ModulePathname>
  /**
   * text describing how the folder for a single record is generated
   *
   * this property is **not** the same as {@link SharePointFolderReference.folder}
   */
  readonly description: string
  readonly primaryKey: PrimaryKey
  constructor({
    id,
    name,
    description,
    module,
    classType,
    primaryKey,
  }: Pick<
    SharePointParentFolderItem<
      ID,
      Name,
      ModuleID,
      ModuleName,
      ModulePathname,
      ClassType,
      PrimaryKey
    >,
    'id' | 'name' | 'description' | 'module' | 'classType' | 'primaryKey'
  >) {
    super(id)
    this.name = name
    this.description = description
    this.module = module
    this.classType = classType
    this.primaryKey = primaryKey
  }
}

export const ConcretePackets = new SharePointParentFolderItem({
  id: 'A775B3E2-A784-4AA0-9C14-B438710876E3',
  module: Concrete,
  name: 'Concrete Packets',
  description: 'Test Set ID',
  classType: 'ConcreteTestSet',
  primaryKey: 'globalId',
})
export const ConstructionAdminSubmittals = new SharePointParentFolderItem({
  id: 'BB6F1050-2E2E-4EA6-A926-48FAC9CDF4EE',
  module: CAS,
  name: 'Construction Admin Submittals',
  description: 'package number and package name joined with a hyphen',
  classType: 'ConstructionAdminSubmittal',
  primaryKey: 'id',
})
export const DesignSubmittals = new SharePointParentFolderItem({
  id: '44705892-6044-4CC2-AE33-2F83B3A8445B',
  module: DS,
  name: 'Design Submittals',
  description: 'package number and package name joined with a hyphen',
  classType: 'DesignSubmittal',
  primaryKey: 'id',
})
export const FieldDesignChanges = new SharePointParentFolderItem({
  id: '91811CAF-B014-4E73-8C06-DF0B760677FB',
  module: FDC,
  name: 'Field Design Changes',
  description: 'number',
  classType: 'FieldDesignChange',
  primaryKey: 'id',
})
export const RequestForInformation = new SharePointParentFolderItem({
  id: 'BD7C6C81-55DC-45F6-9D04-14969FCC2E72',
  module: RFI,
  name: 'Requests For Information',
  description: 'number',
  classType: 'RequestForInformation',
  primaryKey: 'id',
})
export const Issues = new SharePointParentFolderItem({
  id: 'C045BC40-F144-4FA5-B4A7-7BE4626D4619',
  module: Is,
  name: 'Issues',
  description: 'number',
  classType: 'Issue',
  primaryKey: 'id',
})
